// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = 'e13be522ab922692fa61abe9a0865c8479144b1b';
export const BUILD_NUMBER = '214';
export const BUILD_TIMESTAMP = '2026-08-05T03:27:24.661Z';
